 /**
 * Owl Carousel Slider
 */

export default function HWY_SliderTestimonial() {
    this.init = () => {
        testimonialBlockSlide();
    }
    /* Slide Testimonials Block */
    const testimonialBlockSlide = () => {
        jQuery(document).ready(function ($) {
            if( $(".hwy_quote_testimonial .testimonials.owl-carousel").length > 0 ) {
                $(".hwy_quote_testimonial .testimonials.owl-carousel").owlCarousel({
                    items: 1,
                    nav: true,
                    dots: false,
                    loop:true,
                    navText: [
                    `<svg width="15" height="25" viewBox="0 0 15 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13.92 0.522545C12.293 2.19973 11.8411 2.28801 9.85248 3.96519L-8.50266e-06 12.3511L8.40622 20.737C10.0332 22.4142 10.4852 22.5025 11.7507 24.1797L12.9257 23.2087L1.7174 12.3511L14.9143 1.40527L13.92 0.522545Z" fill="#8D8C7F"/>
                </svg>
                `,
                    `<svg width="15" height="25" viewBox="0 0 15 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.994471 24.1796C2.62148 22.5024 3.07344 22.4141 5.06201 20.737L14.9145 12.351L6.50827 3.9651C4.88126 2.28792 4.42929 2.19965 3.16384 0.522461L1.98877 1.49346L13.1971 12.351L0.000213623 23.2969L0.994471 24.1796Z" fill="#8D8C7F"/>
                    </svg>
                    `,
                    ],
                });
            }
        });
    }
}